export default __webpack_public_path__ + "static/byron-bay-bbceaffc47eeefea321232b1ca5fcb13.jpg";